import TypesReducer from './types_reducer';

export default TypesReducer;
